import {
  createCodeableConcept,
  createExtensionValue,
  ExtensionUrl,
  FlagCode,
  findExtensionValue,
} from '@quromedical/fhir-common';

import { type Flag, FlagSchema } from './schema';

export const mapFlagModelToFhir = (flag: Flag): fhir4.Flag => {
  const extension = createExtensionValue(ExtensionUrl.flagNote)(flag.note);

  return {
    resourceType: 'Flag',
    code: createCodeableConcept(FlagCode.clinical),
    status: flag.status,
    subject: flag.subject,
    encounter: flag.encounter,
    author: flag.practitioner,
    period: flag.period,
    extension: [extension],
  };
};

export const mapFhirFlagToModel = (fhirFlag: fhir4.Flag): Flag => {
  const flagModel = {
    note: findExtensionValue(ExtensionUrl.flagNote)(fhirFlag.extension),
    status: fhirFlag.status,
    subject: fhirFlag.subject,
    encounter: fhirFlag.encounter,
    practitioner: fhirFlag.author,
    period: fhirFlag.period,
  };

  const result = FlagSchema.safeParse(flagModel);

  if (!result.success) {
    throw new Error(JSON.stringify(result.error));
  }

  return result.data;
};
